import { application } from "../panel/application"

import CountdownController from "./countdown_controller"
import ClipboardController from "./clipboard_controller"
import IdentityController from "./identity_controller"
import ChimeController from "./chime_controller"
import SoundController from "./sound_controller"

application.register("duel-countdown", CountdownController)
application.register("duel-clipboard", ClipboardController)
application.register("duel-identity", IdentityController)
application.register("duel-chime", ChimeController)
application.register("duel-sound", SoundController)
